var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bannerFrame"}},[_c('tab-frame',{attrs:{"tabs":_vm.tabs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }